import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsRolInternalService } from './edit-dialogs-rolinternal.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-rolinternal',
  templateUrl: './edit-dialogs-rolinternal.component.html',
  styleUrls: ['./edit-dialogs-rolinternal.component.css']
})
export class EditDialogsRolinternalComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsRolInternalService: EditDialogsRolInternalService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsRolinternalComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsRolInternalService.build(); }

  ngOnInit() {
    this.editDialogsRolInternalService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Rol interno
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsRolInternalService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del parameter está ausente
      // -1: El número del parameter ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorRolInternal('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorRolInternal('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog parameters
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let rolinternal = this.editDialogsRolInternalService.rolsInternal;
    let original = this.editDialogsRolInternalService.originalRolsInternal;
    return this.editDialogsRolInternalService.compare(rolinternal, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorRolInternal(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }
  
}
